import { createSelector } from 'reselect'
import { DICT_LANGUAGE } from 'src/utils/constant'

export const selectDefinition = state => state.definition
export const selectDefinitionDictWord = createSelector(
	[selectDefinition],
	definition => definition.dictWord
)
export const selectDefinitionVN = createSelector(
	[selectDefinition],
	definition => definition[DICT_LANGUAGE.VI]
)
export const selectDefinitionEN = createSelector(
	[selectDefinition],
	definition => definition[DICT_LANGUAGE.EN]
)
// export const selectMoreExamples = createSelector(
// 	[selectDefinition],
// 	definition => definition[DICT_LANGUAGE.EN]?.moreExamples
// )
export const selectMoreExamples = createSelector(
	[selectDefinition],
	definition => definition?.dictWord?.moreExamples
)
// Note workaround: Get spelling and definition EN at the same time
export const selectSpelling = createSelector(
	[selectDefinition],
	definition => ({ us: definition.spelling, uk: definition.spellingUk })
)

export const selectTerm = createSelector(
	[selectDefinition],
	definition => definition && definition.term
)

export const selectGetDefinitionLoading = createSelector(
	[selectDefinition],
	definition => definition && definition.isLoading
)

export const selectCurrentDictWordIDFromDef = createSelector(
	[selectDefinition],
	definition => definition && definition.dictWord?.id
)

export const selectCurrentDictWord = createSelector(
	[selectDefinition],
	definition => definition && definition.dictWord
)
export const selectCurrentWordType = createSelector(
	[selectDefinition],
	definition => definition && definition.dictWord
)
